module.exports = __webpack_public_path__ + "img/more_btn_hover.15a94dd8.png";